module.exports = __webpack_public_path__ + "media/img/pages/companies/swissgrid-e42ab0ee8fb0efe25729da9502173d63.jpg";